module.exports = __webpack_public_path__ + "img/assets/curveline--black.svg";